import React, { PureComponent } from 'react'
import { Trans } from '@lingui/react'

import './plan-option.styl'

import { ReadablePrice } from 'client/shared/blocks/readable-price'
import DiscountBadge from 'client/bookmate/blocks/discount-badge'

import { ProductPlan, SpecialOfferPlan } from 'client/shared/types/subscription'
import { GiftPlan } from 'client/bookmate/reducers/gifts-reducer'

type Props = {
  plan: ProductPlan | GiftPlan | SpecialOfferPlan
  hideBadge?: boolean
  price?: number
  priceOption?: 'long' | 'short' | 'mixed' | 'monthly'
  hideStrikedOut?: boolean
  divider?: string
  countFull?: boolean
  extra?: JSX.Element[]
}

export default class PlanOption extends PureComponent<Props> {
  render(): JSX.Element {
    const {
      plan,
      price,
      priceOption,
      divider,
      hideBadge,
      hideStrikedOut,
      extra = [],
      countFull = false,
    } = this.props

    const discountPercent =
      typeof plan.discount_percent === 'number' ? plan.discount_percent : 0

    let fullPrice =
      plan?.regular_price !== plan.price
        ? plan.total_regular_price
          ? plan.total_regular_price
          : plan?.regular_price
        : 0

    if (countFull)
      fullPrice =
        Math.round(
          (Number(plan.discount_percent) / 100 + 1) * (plan.price / 100),
        ) * 100
    return (
      <div className="plan-option">
        <div className="plan-option__inner">
          {Boolean(discountPercent) && !hideBadge && (
            <DiscountBadge
              type="plan-option"
              discountPercent={discountPercent}
            />
          )}
          <div className="plan-option__duration">
            {extra[0]}
            <Trans id={`plan.for_${plan.duration}`} />
          </div>
          <div className="plan-option__price">
            <ReadablePrice
              kind={priceOption || 'short'}
              price={price || plan.price}
              currency={plan.currency}
              className="option-price"
            />
            {divider}
            {Boolean(fullPrice) && !hideStrikedOut && (
              <span className="plan-option__discounted">
                <ReadablePrice
                  kind="short"
                  price={fullPrice}
                  currency={plan.currency}
                />
              </span>
            )}
            {extra[1]}
          </div>
        </div>
      </div>
    )
  }
}
